import { EntityRepository, Repository } from "typeorm";
import { RMReWeighingEntity } from "./rm-re-weighing.entity";

@EntityRepository(RMReWeighingEntity)
export class RMReWeighingRepository extends Repository<RMReWeighingEntity>{

}